module.exports = __webpack_public_path__ + "static/img/img(33).da8ebe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(33).png
// module id = /DXa
// module chunks = 1